import React from 'react'
import './styles.scss'
import modal_img from 'assets/shop/modal.jpg'
import Button from 'components/Button'
import { Link } from 'react-router-dom'

const ModalSuccess = (props) => {
  return (
    <div className="modal">
      <div className="modal__icon">
        <img src={modal_img} alt="image modal" />
      </div>
      <span className="modal__txt">{props.children}</span>
      <div className="modal__btn">
        <Link to={'/shop'}>
          <Button
            size="md"
            borderRadius="detail"
            fontSize="nm"
            backgroundColor="modal"
            color="color"
          >
            Back to shop
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default ModalSuccess
